import {useEffect, useRef} from 'react';

const useModalFocusManagement = ({focusCloseButtonOn}) => {
	const closeButtonRef = useRef(null);
	const modalRef = useRef(null);

	useEffect(() => {
		if (closeButtonRef.current) {
			closeButtonRef.current.focus();
		}
	}, focusCloseButtonOn);

	useEffect(() => {
		const modal = modalRef.current;
		if (!modal) return;

		const handleTabKey = (event) => {
			if (event.key !== 'Tab') return;

			const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
			if (!focusable.length) return;

			const firstFocusable = focusable[0];
			const lastFocusable = focusable[focusable.length - 1];

			if (event.shiftKey && document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}

			if (!event.shiftKey && document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		};

		modal.addEventListener('keydown', handleTabKey);
		return () => modal.removeEventListener('keydown', handleTabKey);
	}, []);

	return {
		modalRef,
		closeButtonRef,
	};
};

export default useModalFocusManagement;
